// Клиентская проводка: сборка getConfig() для martyrs — env, head, меты,
// реестр лениво загружаемых модулей. Серверные ключи и данные БД — в
// server.config.js, сюда они не попадают: этот файл едет в браузерный бандл.

// Фабрика для создания конфигурации
export async function getConfig() {
  return {
    env: {
      NODE_ENV: process.env.NODE_ENV,
      DOMAIN_URL: process.env.DOMAIN_URL,
      API_URL: process.env.API_URL,
      WSS_URL: process.env.WSS_URL,
      MOBILE_APP: process.env.MOBILE_APP,
      FILE_SERVER_URL: process.env.FILE_SERVER_URL,
      GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY
    },
    core: {
      websocket: true,
    },
    app: {
      messages: {
        ru: {
          meta: {
            title: "OZ INTERACTIVE – исследование, аналитика, проектирование, дизайн и разработка",
            description: "Digital агентство полного цикла. Мы предоставляем уникальный опыт в разработке сложных проектов.",
            keywords: "digital production, digital агенство, веб студия, агенство полного цикла",
            og: {
              title: "OZ INTERACTIVE – исследование, аналитика, проектирование, дизайн и разработка",
              description: "Digital агентство полного цикла. Мы предоставляем уникальный опыт в разработке сложных проектов.",
              image: "https://oz.digital/favicon/favicon-96x96.png"
            },
            twitter: {
              title: "OZ INTERACTIVE – исследование, аналитика, проектирование, дизайн и разработка",
              description: "Digital агентство полного цикла. Мы предоставляем уникальный опыт в разработке сложных проектов.",
              image: "https://oz.digital/favicon/favicon-96x96.png",
              card: "summary_large_image"
            },
            htmlAttrs: {
              lang: "ru"
            }
          }
        },
        en: {
          meta: {
            title: "OZ INTERACTIVE – research, analytics, design and development",
            description: "Full-service digital agency. We provide unique expertise in developing complex projects.",
            keywords: "digital production, digital agency, web studio, full-service agency",
            og: {
              title: "OZ INTERACTIVE – research, analytics, design and development",
              description: "Full-service digital agency. We provide unique expertise in developing complex projects.",
              image: "https://oz.digital/favicon/favicon-96x96.png"
            },
            twitter: {
              title: "OZ INTERACTIVE – research, analytics, design and development",
              description: "Full-service digital agency. We provide unique expertise in developing complex projects.",
              image: "https://oz.digital/favicon/favicon-96x96.png",
              card: "summary_large_image"
            },
            htmlAttrs: {
              lang: "en"
            }
          }
        }
      },
    },
    modules: {
      currency: '₽',
      auth: {
        authMethodsExclude: ['phone'],
        loader: () => import('@ozdao/martyrs/modules/auth/client'),
        routes: ['/auth', '/backoffice'],
        contexts: ['backoffice'],
        priority: 'high',
        dependencies: ['backoffice']
      },
      organizations: {
        loader: () => import(
          /* webpackChunkName: "module-organizations" */
          '@ozdao/martyrs/modules/organizations/client'
        ),
        routes: ['/backoffice/organizations'],
        contexts: ['backoffice'],
        preload: true,
        priority: 'normal',
        dependencies: ['backoffice']
      },
      backoffice: {
        loader: () => import(
          /* webpackChunkName: "module-backoffice" */
          '@ozdao/martyrs/modules/backoffice/client'
        ),
        routes: ['/backoffice', '/admin'],
        priority: 'normal',
        dependencies: []
      },
      // products: {
      //   loader: () => import(
      //     /* webpackChunkName: "module-products" */
      //     '@ozdao/martyrs/modules/products/client'
      //   ),
      //   routes: [
      //     '/backoffice/products',
      //     '/backoffice/categories'
      //   ],
      //   contexts: ['backoffice'],
      //   priority: 'normal',
      //   dependencies: ['organizations']
      // },
      orders: {
        allowUnauthenticatedOrders: true,
        loader: () => import(
          /* webpackChunkName: "module-orders" */
          '@ozdao/martyrs/modules/orders/client'
        ),
        routes: [
          '/backoffice/orders',
          '/backoffice/customers',
          '/backoffice/applications'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['backoffice'],
        statuses: [
          {
            value: 'created',
            label: 'New',
            description: 'Your request has been received and is awaiting review.'
          },
          {
            value: 'confirmed',
            label: 'Confirmed',
            description: 'Your request has been confirmed. We will reach out with further details shortly.'
          },
          {
            value: 'in_progress',
            label: 'In Progress',
            description: 'Your request is currently being processed.'
          },
          {
            value: 'finished',
            label: 'Completed',
            description: 'Your request has been fulfilled. Thank you for choosing OZ INTERACTIVE.'
          },
          {
            value: 'cancelled',
            label: 'Cancelled',
            description: 'This request has been cancelled.'
          }
        ],
        showFees: false,
        feesRate: 0,
        showVat: false,
        vatRate: 0,
        showDeliveryFee: false,
        deliveryRate: 0,
      },
    }
  };
}